import { trpc } from "@/trpc/client";
import { applyCampaignSiteSlugNames } from "@/utils/campaignSiteSlug";
import {
  campaignBrowsers,
  campaignPurchaseTree,
  campaignSiteRows,
  channelPlacements,
  listCampaignSites,
  placementCreatives,
  purchaseTotals,
  reportRequests,
  siteBrowsers,
} from "@/trpc/calls";
import { campaignIdFrom, readDateRange, siteIdFrom } from "@/trpc/listFilter";

function analyticsBase(variables) {
  const campaignId = campaignIdFrom(variables);
  const range = readDateRange(variables) || {};
  const siteId = siteIdFrom(variables);
  return {
    campaign_id: campaignId,
    ...(range.start_datetime ? { start_datetime: range.start_datetime } : {}),
    ...(range.end_datetime ? { end_datetime: range.end_datetime } : {}),
    ...(siteId ? { site_id: siteId } : {}),
    live: true,
  };
}

const fetchGeneralTableSites = async (variables) => {
  const sites = await campaignSiteRows(variables);
  return applyCampaignSiteSlugNames(sites, variables);
};

const getPurchasesTypesTotalSite = async (variables) => purchaseTotals(variables);

const getPurchasesTypesTotalSites = async (variables) => {
  const tree = await campaignPurchaseTree(variables);
  return tree?.sites ?? tree ?? [];
};

const getPurchasesTypesTotalSiteCategorySafeframe = async (variables) => {
  const base = analyticsBase(variables);
  if (!base.campaign_id) return null;
  const result = await trpc.analytics.siteChannelsQuality.query(base);
  return result?.rows?.[0] ?? result?.sites?.[0] ?? result ?? null;
};

const getPurchasesTypesTotal = async (variables) => purchaseTotals(variables);

const getPurchasesTypesTotalCategorySafeframe = async (variables) => {
  const base = analyticsBase(variables);
  if (!base.campaign_id) return null;
  return trpc.analytics.siteChannelsQuality.query(base);
};

const getSensitiveUrl = async (variables) => {
  const base = analyticsBase(variables);
  if (!base.campaign_id) return null;
  try {
    const result = await trpc.analytics.urlSites.query({ ...base, limit: 200 });
    return applyCampaignSiteSlugNames(result?.rows ?? result ?? [], variables);
  } catch (error) {
    console.error("Erro ao obter dados das urls sensiveis:", error);
    return [];
  }
};

const table_verification_getData = async (variables) => {
  const base = analyticsBase(variables);
  if (!base.campaign_id) return [];
  const result = await trpc.analytics.urls.query({ ...base, limit: 200 });
  return applyCampaignSiteSlugNames(result?.rows ?? result ?? [], variables);
};

const table_verification_getData_count = async (variables) =>
  table_verification_getData(variables);

const categoriesData = async () => {
  try {
    const result = await trpc.verification.categories.query();
    return result;
  } catch {
    return { categories: [] };
  }
};

const sitesDataCampaign = async (variables) => {
  const sites = await listCampaignSites(variables);
  return applyCampaignSiteSlugNames(sites, variables);
};

const campaignBrowser = async (variables) => campaignBrowsers(variables);
const siteBrowser = async (variables) => siteBrowsers(variables);
const Reports_getData = async (variables) => reportRequests(variables);

const getChannelGeneralTable = async (variables) => {
  const tree = await campaignPurchaseTree(variables);
  const channels = tree?.channels ?? tree?.sites?.flatMap((s) => s.channels || []) ?? [];
  return applyCampaignSiteSlugNames(channels, variables);
};

const getChannelGeneralTableCategorySafeframe = async (variables) => {
  const base = analyticsBase(variables);
  if (!base.campaign_id) return [];
  const result = await trpc.analytics.siteChannelsQuality.query(base);
  return applyCampaignSiteSlugNames(result?.channels ?? result?.rows ?? [], variables);
};

const getSiteGeneralTableNew = async (variables) => fetchGeneralTableSites(variables);

const getSiteGeneralTableNewCategorySafeframe = async (variables) => {
  const base = analyticsBase(variables);
  if (!base.campaign_id) return [];
  const result = await trpc.analytics.siteChannelsQuality.query(base);
  return applyCampaignSiteSlugNames(result?.sites ?? result?.rows ?? [], variables);
};

const getPlacementsGeneralTable = async (variables) => {
  try {
    return await channelPlacements(variables);
  } catch {
    return [];
  }
};

const getPlacementsGeneralTableCategorySafeframe = async (variables) => {
  try {
    return await channelPlacements(variables);
  } catch {
    return [];
  }
};

const getCreativesGeneralTable = async (variables) => {
  try {
    return await placementCreatives(variables);
  } catch {
    return [];
  }
};

const getCreativesGeneralTableCategorySafeframe = async (variables) => {
  try {
    return await placementCreatives(variables);
  } catch {
    return [];
  }
};

const getSessions = async (variables) => {
  const base = analyticsBase(variables);
  if (!base.campaign_id) return [];
  try {
    const result = await trpc.analytics.sessions.query(base);
    return applyCampaignSiteSlugNames(result?.rows ?? result?.sites ?? [], variables);
  } catch {
    return [];
  }
};

const getIps = async (variables) => {
  const base = analyticsBase(variables);
  if (!base.campaign_id) return [];
  try {
    const result = await trpc.analytics.ips.query(base);
    return applyCampaignSiteSlugNames(result?.rows ?? result?.sites ?? [], variables);
  } catch {
    return [];
  }
};

export {
  getPurchasesTypesTotal,
  getPurchasesTypesTotalCategorySafeframe,
  getSensitiveUrl,
  categoriesData,
  sitesDataCampaign,
  table_verification_getData,
  table_verification_getData_count,
  campaignBrowser,
  Reports_getData,
  getChannelGeneralTable,
  getChannelGeneralTableCategorySafeframe,
  getSiteGeneralTableNew,
  getSiteGeneralTableNewCategorySafeframe,
  getPlacementsGeneralTable,
  getPlacementsGeneralTableCategorySafeframe,
  getCreativesGeneralTable,
  getCreativesGeneralTableCategorySafeframe,
  getSessions,
  getIps,
  getPurchasesTypesTotalSite,
  getPurchasesTypesTotalSites,
  getPurchasesTypesTotalSiteCategorySafeframe,
  siteBrowser,
};
